
const Swal = require('sweetalert2');

export const showError = (message, title = "Error") => {
  Swal.fire({
    icon: 'error',
    title: title,
    text: message,
    confirmButtonText: 'OK',
  });
}

export const showSuccess = (message, title = "Success") => {
  Swal.fire({
    icon: 'success',
    title: title,
    text: message,
    confirmButtonColor: '#23303D',
  });
}
